<app-breadcrumb [master]="'Administracja'" [parentName]="'Direct'" [name]="'Szczegóły\n'"></app-breadcrumb>
<mat-tab-group >
  <mat-tab label="Dane">
<app-hiperio-config-direct-details-view [hiperioConfigDirect]="hiperioConfigDirect" (modifyClicked)="load()" ></app-hiperio-config-direct-details-view>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list  [hiperioConfigDirect]="hiperioConfigDirect"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
